module.exports = __webpack_public_path__ + "static/img/pic_right.e0c6f69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pic_right.png
// module id = QDqO
// module chunks = 1